
<!-- 签到记录 -->
<template>
  <div class="home-page">
    <div class="date">
      <div @click="changeMonth">
        {{ month }}
        <van-icon class-prefix="vxs-icon" name="system_choose" size="16" />
      </div>
    </div>

    <vx-list
      class="list"
      enable
      :api="api"
      :params="params"
      @load="load"
      ref="vxList"
      @refresh="loading = true"
    >
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="$router.push(`/face/detail/${item.id}`)"
      >
        <div class="student-name">
          {{ item.studentName.substr(-2) }}
          <!-- <img
            v-if="item.faceInType == 1"
            class="img"
            src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/017.png"
          />
          <img
            v-else
            class="img"
            src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/016.png"
          /> -->
        </div>
        <div class="info-wrap">
          <div class="info flex-between van-hairline--bottom">
            <div>
              <div>
                <span v-if="item.faceInType == 1" class="c1">到校</span>
                <span v-else class="c2">离校</span>
                {{item.faceInType == 1 ? '签到' :'签退'}}：
                {{ item.faceInFullTime | formatDatetime('yyyy-MM-dd hh:mm') }}
              </div>
              <div class="local">{{ item.companyName }}-{{ item.campusName }}</div>
            </div>
            <!-- <img class="photo" :src="item.faceUrl" /> -->
            <div class="photo" :style="`background-image: url('${item.faceUrl}');`"></div>
          </div>
        </div>
      </div>
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="暂无签到记录"
        v-if="hasStudents && (!list || !list.length) && !loading"
        image-size="128"
      >
      </van-empty>
    </vx-list>

    <empty-page
      :show="!hasStudents && !loading"
      :isNoBindStudent="true"
      tips=""
      class="nobind-empty"
    >
      <div class="t1">还未绑定学员</div>
      <div class="t2">请联系机构老师进行绑定</div>
    </empty-page>
  </div>
</template>

<script>
import EmptyPage from '@parent/components/empty-page.vue';

export default {
  name: 'face-list',
  data() {
    let isFaceApp = app.parent.app_type == 'face';
    return {
      pageTitle: '签到记录',
      month: app.tool.date.formatDatetime(new Date(), 'yyyy年MM月'),
      api: this.$api.getGzhHome,
      list: [],
      loading: true,
      hasStudents: false,
      params: {
        faceinTime: app.tool.date.formatDatetime(new Date(), 'yyyy-MM'), //人脸打卡时间
        companyId: isFaceApp ? '' : app.tool.parseQuery().companyId,
      },
    };
  },
  methods: {
    changeMonth() {
      app.x3.picker
        .datetime({
          type: 'year-month',
          'min-date': new Date('2020/01/01'),
          'max-date': new Date(),
          value: new Date(this.month.replace('年', '/').replace('月', '/01')),
          formatter: (type, val) => {
            if (type === 'year') {
              return `${val}年`;
            } else if (type === 'month') {
              return `${val}月`;
            }
            return val;
          },
        })
        .then(res => {
          this.month = app.tool.date.formatDatetime(res, 'yyyy年MM月');
          this.params.faceinTime = app.tool.date.formatDatetime(res, 'yyyy-MM');
        });
    },
    load(list, res) {
      if (res.code == 200) {
        this.hasStudents = res.data.hasStudents;
        if (res.data.hasStudents) {
          if (res.page.pageNum == 1) {
            this.list = [];
          }
          this.list = this.list.concat(res.data.recordList);
        }
      }
      vant.Toast.clear();
      this.loading = false;
    },
  },
  created() {
    this.showLoading();
  },
  components: {
    EmptyPage,
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  .date {
    padding: 12px 16px;
  }
  .list {
    flex: 1;
    overflow: auto;
    position: relative;
    .item {
      padding: 0 16px;
      position: relative;
      .student-name {
        position: absolute;
        left: 16px;
        top: 14px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        background-color: #1952e1;
        color: var(--white);
        text-align: center;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .info-wrap {
        padding-left: 48px;
        .photo {
          width: 44px;
          height: 44px;
          border-radius: 2px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
        .info {
          padding: 12px 0;
          .c1 {
            color: var(--c2);
          }
          .c2 {
            color: var(--c1);
          }
          .local {
            margin-top: 2px;
            color: var(--g6);
            font-size: var(--fs-sm);
            line-height: var(--lh-md);
          }
        }
      }
    }
  }
  .nobind-empty {
    background-color: var(--white);
    .t1 {
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
    }
    .t2 {
      margin-top: 8px;
      color: var(--g6);
    }
  }
}
</style>